import React, { useMemo } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const STAR_COLORS = {
  1: "#ef4444",
  2: "#f97316",
  3: "#eab308",
  4: "#84cc16",
  5: "#22c55e",
};

const tooltipStyle = {
  contentStyle: {
    backgroundColor: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
    fontSize: "13px",
  },
};

const FiveStarCard = React.memo(({ data }) => {
  const { chartData, total } = useMemo(() => {
    if (!data || !data.length) return { chartData: [], total: 0 };

    const total = data.reduce((sum, d) => sum + (d.count || 0), 0);
    const chartData = data
      .filter((d) => d.stars >= 1 && d.stars <= 5)
      .map((d) => ({
        name: `${d.stars} Star${d.stars !== 1 ? "s" : ""}`,
        value: d.count,
        stars: d.stars,
      }));

    return { chartData, total };
  }, [data]);

  return (
    <div className="overview-metric-card">
      <div className="metric-header">
        <div className="metric-info">
          <h4 className="metric-title">Five Star Ratings</h4>
          <div className="metric-total">
            <a href="/reports/fivestar-rating">{total.toLocaleString()}</a>
          </div>
          <div className="metric-details">
            <span className="metric-avg">{total} rating{total !== 1 ? "s" : ""} total</span>
          </div>
        </div>
      </div>
      <div className="metric-chart">
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={45}
                outerRadius={75}
                dataKey="value"
                paddingAngle={2}
                animationDuration={800}
              >
                {chartData.map((entry) => (
                  <Cell
                    key={entry.name}
                    fill={STAR_COLORS[entry.stars] || "#94a3b8"}
                  />
                ))}
              </Pie>
              <Tooltip {...tooltipStyle} />
              <Legend
                iconType="circle"
                iconSize={8}
                wrapperStyle={{ fontSize: "11px" }}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="metric-no-data">No ratings for this period</div>
        )}
      </div>
    </div>
  );
});

FiveStarCard.displayName = "FiveStarCard";

export default FiveStarCard;
